import type { ReactNode } from 'react';

import { styles } from '@actual-app/components/styles';
import { Text } from '@actual-app/components/text';
import { TextOneLine } from '@actual-app/components/text-one-line';
import { View } from '@actual-app/components/view';

import { color } from '#components/mobile/ui/tokens';
import { PrivacyFilter } from '#components/PrivacyFilter';

/** Fila de una tarjeta de Informes: punto de color, nombre, nota y cifra. */
export function FilaDato({
  colorPunto,
  nombre,
  nota,
  valor,
  colorNota = color.fg3,
}: {
  colorPunto: string;
  nombre: string;
  nota?: ReactNode;
  valor: string;
  colorNota?: string;
}) {
  return (
    <View
      style={{
        flexDirection: 'row',
        alignItems: 'center',
        gap: 8,
        minHeight: 26,
      }}
    >
      <View
        style={{
          width: 9,
          height: 9,
          borderRadius: 5,
          backgroundColor: colorPunto,
          flexShrink: 0,
        }}
      />
      <TextOneLine
        style={{
          ...styles.smallText,
          flex: 1,
          fontWeight: 700,
          color: color.fg,
        }}
      >
        {nombre}
      </TextOneLine>
      {nota != null && (
        <Text
          style={{
            ...styles.smallText,
            ...styles.tnum,
            fontWeight: 700,
            color: colorNota,
          }}
        >
          {nota}
        </Text>
      )}
      <PrivacyFilter>
        <Text
          style={{
            ...styles.smallText,
            ...styles.tnum,
            color: color.fg2,
            minWidth: 52,
            textAlign: 'right',
          }}
        >
          {valor}
        </Text>
      </PrivacyFilter>
    </View>
  );
}
